import {setupPlayer} from "../setup-player";

export function autoSetup() {
    const elements = document.querySelectorAll("mg-video")

    for(const element of elements) {

        const settings = {
            url: element.url,
            autoplay: element.autoplay,
            muted: element.muted,
            app: element.app,
            key: element.key,
            errorImage: element.errorImage,
            fullpage: element.fullpage,
            showErrorMessage: element.showErrorMessage
        }

        setupPlayer(element, settings)
    }
}
